export const CODE_NATIONAL = "HVE1";

const exports = { codeNational: CODE_NATIONAL };
export default exports;
